import React from "react";
import { Link } from "react-router-dom";

// Import images
import MicIcon from "../../../asset/images/home/icon/fi-rr-microphone-alt.png";
import FalseIcon from "../../../asset/images/home/icon/false.png";
import Img1 from "../../../asset/images/home/modules/1.png";
import Img2 from "../../../asset/images/home/modules/2.png";
import Img3 from "../../../asset/images/home/modules/3.png";
import Img4 from "../../../asset/images/home/modules/4.png";
import Img5 from "../../../asset/images/home/modules/5.png";

function CardVowelDo() {
    return (
        <div className="flex justify-center items-center min-h-screen">

            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 13: Decoding Multi-Syllabic words
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Virtual Class Demo
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        that you’ve learned how to teach students to learn the sounds of the alphabet, let’s take this further by demonstrating with A.I. students. These are compliant students that will repeat whatever you say. There is an expectation for a correct response from you.
                    </p>
                </div>

                {/* Do Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-32 flex items-center justify-center">
                        <img
                            src={MicIcon}
                            height="20"
                            width="20"
                            className="mr-2"
                            alt="Microphone"
                        />
                        Do
                    </button>
                </div>

                {/* Student Images Section */}
                <div className="relative flex justify-center gap-2 flex-wrap bg-[#E1494233] py-6 rounded-xl mb-8 border-4 border-[#E14942]">

                    {/* Tick Icon */}
                    <img
                        src={FalseIcon}
                        alt="Status"
                        className="absolute top-2 right-2 w-8 h-8"
                    />

                    {/* Student Images */}
                    <img src={Img1} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Img2} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Img3} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Img4} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Img5} alt="Student" className="w-50 h-50 object-cover" />
                </div>

                {/* Card Section */}
                <div className="max-w-7xl mx-auto">
                    <div className="bg-white border border-primary rounded-xl py-16 shadow-lg">

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 items-center">

                            {/* Left faded card */}
                            <div className="flex justify-center opacity-40">
                                <div className="relative w-40 h-40">

                                    <div className="absolute right-6 w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200 shadow-xl"></div>
                                    <div className="absolute right-3 w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200"></div>

                                    <div className="relative w-40 h-40 bg-[#FFFFFF] rounded-2xl border border-gray-200 flex items-center justify-center text-4xl font-bold text-gray-400 shadow-xl">
                                        Mm
                                    </div>
                                </div>
                            </div>

                            {/* Center Card */}
                            <div className="flex justify-center">
                                <div className="w-48 h-48 bg-[#FFFFFF] rounded-2xl border border-gray-200 flex flex-col items-center justify-center text-gray-800 shadow-xl">
                                    <span className="text-5xl text-gray-800">Kk</span>
                                    <span className="text-md mt-1">Click on card</span>
                                </div>
                            </div>

                            {/* Right Heading */}
                            <div className="p-3">
                                <h4 className="text-4xl font-bold">K says ...</h4>
                            </div>

                        </div>

                        {/* Letters Buttons */}
                        <div className="text-center lg:mt-10 mt-6">
                            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6">

                                <button className="letter-btn bg-[#1A588B] text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20 rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-5xl">
                                    a
                                </button>

                                <button className="letter-btn bg-[#D5B641] text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20 rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-5xl">
                                    e
                                </button>

                                <button className="letter-btn bg-[#439D55] text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20 rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-5xl">
                                    i
                                </button>

                                <button className="letter-btn bg-[#E14942] text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20 rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-5xl">
                                    o
                                </button>

                                <div className="border-2 border-[#E14942] rounded-lg py-1 px-1">
                                    <button className="letter-btn bg-[#374957] text-white w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20 rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-5xl">
                                        u
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                {/* Navigation Button */}
                <div className="flex justify-center mt-5">
                    <Link to="#">
                        <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Next →
                        </button>
                    </Link>
                </div>

            </main>

        </div>
    );
}

export default CardVowelDo;
